// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a12a2164","821":"7c4f1137"}[chunkId] + ".chunk.js";
};